/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(0.75),
      justifyContent: "center",
    },
    icon: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      color: theme.palette.text.secondary,
    },
    titleText: {
      fontWeight: "500",
      fontSize: theme.spacing(3),
      marginTop: theme.spacing(1),
      lineHeight: theme.spacing(3.5),
      color: theme.palette.text.primary,
    },
    innerContent: {
      top: "40%",
      textAlign: "center",
      position: "absolute",
    },
    subTitleText: {
      marginTop: theme.spacing(2),
      fontSize: theme.spacing(1.75),
      color: theme.palette.text.primary,
    },
    buttonAlignment: {
      padding: theme.spacing(1, 2),
      marginTop: theme.spacing(2.5),
    },
  });
});

export { useStyles };
